import React from 'react';
import { EntityDescription } from '../../Api/interfaces';
import './styles.css';

interface Props {
  entityType: EntityDescription;
  onTypeClicked?: (type: string) => void;
}

interface State {
  entityType: EntityDescription;
}

export default class EntityDescriptionHeader extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { entityType: props.entityType };
  }

  private typeClicked(): void {
    const event = this.props.onTypeClicked;
    if (event) {
      event(this.props.entityType.typeName);
    }
  }

  public render(): JSX.Element {
    const entity = this.props.entityType;
    const className = (this.state.entityType.isSelected) ? 'selectedTypeNameItem' : 'typeNameItem';

    return (
      <li className={className} key={entity.typeName} onClick={() => this.typeClicked()}>
        <div className="typeName">{entity.label}</div>
        <div className="type">[{entity.typeName}]</div>
      </li>
    );
  }
}
